export const ANALYTIC_START_PERIOD_BX = {
  quarter: 1,
  year: 2025,
};

export const DEFAULT_FILTER_ASSET_MANAGERS_BX = ["BX Partners"];

export const DEFAULT_FILTER_TYPE_BX = ["Index"];
